import { BridgeInterface } from '@completeanatomy/bridge-schema';
import { kcGateway } from './keycloak';

class Bridge extends BridgeInterface {
  private bridge: any;

  protected dispatch<T = any>(
    selector: string,
    parameters: [any]
  ): T | Promise<T> {
    let trimmedSelector = selector;

    if (selector[selector.length - 1] === ':') {
      trimmedSelector = selector.substring(0, selector.length - 1);
    }

    const wasm = window.Module;

    if (wasm === undefined) {
      console.error('WASM not loaded');

      return {} as T;
    }

    if (!wasm.application) {
      // I don't like it being an error
      console.warn('Application not loaded');

      return {} as T;
    }

    if (this.bridge === undefined) {
      this.bridge = wasm.application.getBridge();
    }

    const bridgeMethodType = typeof this.bridge[trimmedSelector];

    if (bridgeMethodType === 'function') {
      if (this.bridge[trimmedSelector].length > 0) {
        this.bridge[trimmedSelector](
          typeof parameters[0] === 'object'
            ? JSON.stringify(parameters[0])
            : parameters[0]
        );
      } else {
        this.bridge[trimmedSelector]();
      }
    } else {
      console.error(
        trimmedSelector +
          ' - Method not found, please implement it in the WASM bridge'
      );
    }

    return {} as T;
  }

  public logout(): Promise<void> | void {
    return kcGateway.logout();
  }

  public authenticate(): Promise<void> | void {
    return kcGateway.login();
  }

  public refresh(): Promise<void> | void {
    return kcGateway.login();
  }

  public openURL(options?: { link: string }): Promise<void> | void {
    if (options?.link) {
      window.open(options.link);
    }
  }

  public setAppLanguage(): Promise<void> | void {
    // fix wasm error
  }
}

export default new Bridge();
